<script>
	import ImageOptimiser from '$lib/components/common/ImageOptimiser.svelte';
	import { page } from '$app/stores';
	import SlideModal from '$vl/lib/components/SlideModal.svelte';

	// images
	import Home from '$vl/lib/assets/icons/modal-icons/home.svelte';
	import AboutUs from '$vl/lib/assets/icons/modal-icons/about_us.svelte';
	import ContactUs from '$vl/lib/assets/icons/modal-icons/contact_us.svelte';
	import Faq from '$vl/lib/assets/icons/modal-icons/faq.svelte';
	import Shop from '$vl/lib/assets/icons/modal-icons/shop.svelte';
	import ProfileIcon from '$vl/lib/assets/icons/modal-icons/profile.svelte';
	import logo from '$vl/lib/assets/icons/vl_logo.svg';
	import cross from '$vl/lib/assets/icons/cross.svelte';
	import Menu from '$vl/lib/assets/icons/vl_menu.svelte';
	import Profile from '$vl/lib/assets/icons/profile.svelte';
	import { pushState } from '$app/navigation';
	import Icon from '$lib/components/common/Icon.svelte';
	import Cross from '../assets/icons/cross.svelte';

	let navLinks = [
		{ name: 'Home',
		 link: '/',
		  icon: Home },
		{
			name: 'About Us',
			link: 'https://vibrantliving.in/pages/about-us',
			icon: AboutUs
		},
		{
			name: 'Contact Us',
			link: 'https://vibrantliving.in/pages/contact',
			icon: ContactUs
		},
		{ name: 'FAQs',
		 link: '/faqs',
		  icon: Faq },
		{
			name: 'Shop Online',
			link: 'https://vibrantliving.in',
			icon: Shop
		},
		{
			name: 'Profile',
			link: '/apex/account',
			icon: ProfileIcon
		}
	];

	const showModal = () => {
		pushState('', {
			showSlideDownModal: { menu: true }
		});
	};

	const closeModal = () => {
		history.back();
	};
</script>

<SlideModal id="menu" on:click={closeModal}>
	<div slot="content">
		<div class=" items-starts flex flex-col justify-start text-center">
			{#each navLinks as item}
				<a
					href={item.link}
					class="link-before flex h-[58px] cursor-pointer items-center justify-start gap-2 pl-6 hover:bg-[#FBDACD]"
					class:link-active={$page.url.pathname === item.link}
				>
				<item.icon></item.icon>
					<!-- <ImageOptimiser
						src={item.icon}
						alt={item.name}
						classes={{ container: 'w-[20px] h-[20px]', image: 'w-full h-full object-cover' }}
					/> -->
					{item.name}
				</a>
			{/each}
		</div>
	</div>
</SlideModal>

<div
	class="sticky top-0 z-40 flex h-[82px] items-end justify-between bg-white px-6 md:items-center lg:h-[100px] lg:px-20"
>
	<a class="mb-[-10px] md:place-self-end lg:-mb-4" href="https://www.vibrantliving.in">
		<ImageOptimiser
			src={logo}
			alt="logo"
			classes={{
				container: 'w-20 h-[45px] md:w-[120px] md:h-[68px]',
				image: 'w-full h-full object-cover'
			}}
		/>
	</a>
	<div class="ml-auto md:hidden">
		{#if $page.state.showSlideDownModal && $page.state.showSlideDownModal.menu}
			<button on:click={closeModal} class="p-3">
				<div class="w-full h-full object-cover">
					<Cross />
				</div>
				<!-- <ImageOptimiser
					src={cross}
					alt="menu"
					classes={{ container: 'w-6 h-6', image: 'w-full h-full object-cover' }}
				/> -->
			</button>
		{:else}
			<button on:click={showModal} class="p-3">
				<Menu />
				<!-- <ImageOptimiser
					src={menu}
					alt="menu"
					classes={{ container: 'w-6 h-6', image: 'w-full h-full object-cover' }}
				/> -->
			</button>
		{/if}
	</div>
	<div class="hidden md:block">
		<ul class="gap-6 text-base font-medium md:flex">
			{#each navLinks.slice(0, 5) as item, i}
				<li>
					<a
						class="hover-text primary-text underline-offset-8 hover:font-bold hover:underline hover:decoration-[#F15922]"
						class:active={$page.url.pathname === item.link}
						href={item.link}>{item.name}</a
					>
				</li>
			{/each}
		</ul>
	</div>
	<div>
		<a
			class="primary-text hidden gap-2 text-base font-medium md:flex"
			href="/apex/account"
			data-sveltekit-preload-data="off"
		><Profile></Profile>
			<!-- <ImageOptimiser
				src={profile}
				alt="profile"
				classes={{ container: 'w-5 h-5', image: 'w-full h-full object-cover' }}
			/> -->
			Profile
		</a>
	</div>
</div>

<style>
	.primary-text {
		color: #837c7c;
	}
	.active {
		color: #f15922;
		font-weight: bold;
		text-decoration: underline;
		text-underline-offset: 8px;
		text-decoration-color: #f15922;
	}
	.link-active {
		background-color: #fbdacd;
	}
	.link-before:hover::before {
		content: '';
		position: fixed;
		left: 0px;
		height: 58px;
		width: 5.44px;
		background-color: #f26b3a;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
	}
</style>
